import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import {
  fetchEventDetailsDone,
  fetchEventDetailsError,
  fetchEventStatusDone
} from "../../state/events/actions";
import { GET_EVENT_DETAILS } from "../../state/events/constants";

function* fetchDetails({ event }) {
  try {
    const { id, streamType, compareStatus = false } = event;
    const url = GET_EVENT_DETAILS.replace(":eventId", id).replace(
      ":eventType",
      streamType // Video or Audio
    );
    const result = yield call(Axios.core.get, url);
    const data = result.data ? { ...result.data, streamType } : {};
    if (!compareStatus) {
      yield put(fetchEventDetailsDone(data));
    } else {
      yield put(
        fetchEventStatusDone({
          startTime: result.data.startTime,
          status: result.data.status
        })
      );
    }
  } catch (e) {
    yield put(fetchEventDetailsError(e));
  }
}

export default fetchDetails;
